<template>
  <div class="loading" :class="{'active': isLoading}">
    <div class="icon icon-loading"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "LoadingAnimation",
  computed: {
    ...mapGetters(['isLoading']),
  }
}
</script>